import React, { useState } from "react";
import API from "../axiosInstance";
import "./ProfileEditModal.css";

export default function BioModal({ onClose }) {

  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const email = currentUser?.email;

  const [bio, setBio] = useState(currentUser.bio || "");
  const [msg, setMsg] = useState("");

  const handleSave = async () => {
    if (!bio) return setMsg("Bio requise");

    try {
      const res = await API.post("/users/update-bio", { email, bio });
      if (res.data.ok) {
        const updated = { ...currentUser, bio };
        localStorage.setItem("currentUser", JSON.stringify(updated));
        onClose();
        window.location.reload();
      }
    } catch {
      setMsg("Erreur");
    }
  };

  return (
    <div className="profile-modal-overlay">
      <div className="profile-modal">
        
        <h2>Modifier ta bio</h2>

        <textarea
          value={bio}
          onChange={(e)=>setBio(e.target.value)}
          rows={4}
        />

        <p style={{color:"red"}}>{msg}</p>

        <button onClick={handleSave}>Enregistrer</button>
        <button onClick={onClose}>Fermer</button>
      </div>
    </div>
  );
}
